import axios from 'axios';
import { tokenUtils } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL + '/Teacher';

function getAuthHeaders() {
  const token = tokenUtils.get();
  if (!token) throw new Error('No se encontró token de autenticación');
  return {
    Authorization: `Bearer ${token}`,
  };
}

const getTeachers = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener profesores:', error);
    throw error;
  }
};
 
const getTeacher = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status !== 404) {
      console.error(`Error al obtener el profesor con id ${id}:`, error);
    }
    throw error;
  }
};

const teacherService = {
  getTeachers,
  getTeacher,
};

export default teacherService;
